export const currency = (total: number): string => {
  return Intl.NumberFormat('en-LK', {
    style: 'currency',
    currency: 'LKR',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(total);
};
